<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-img
        v-if="!loading && item.img_desktop"
        class="d-flex align-center justify-center item"
        :aspect-ratio="xsOnly ? 600 / 600 : 1920 / 530"
        min-height="400px"
        :position="!smAndDown ? 'center right' : 'center center'"
        cover
        :src="
          files +
          (xsOnly && item.img_mobile
            ? item.img_mobile + '?resize=1&w=600'
            : item.img_desktop + '?resize=1&w=1920')
        "
      >
        <v-container class="item-caption">
          <div
            v-if="item.title"
            class="
              white--text
              text-h5 text-sm-h4 text-md-h3 text-center text-sm-left
              font-weight-black font-italic
              item-title
            "
          >
            <span class="font-secondary">
              {{ item.title }}
            </span>
          </div>

          <div
            v-if="item.subtitle"
            class="
              white--text
              text-h6 text-sm-h5 text-md-h4 text-center text-sm-left
              font-italic
              item-subtitle
            "
          >
            <span class="font-secondary">
              {{ item.subtitle }}
            </span>
          </div>

          <ButtonWidget
            v-if="item.btn_link"
            class="text-center text-sm-left mt-8"
            :href="item.btn_link"
            :target="item.target ? '_blank' : '_self'"
            secondary
          >
            {{ item.btn_text || "Saiba Mais" }}
          </ButtonWidget>
        </v-container>
      </v-img>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "shippingBanner",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    LoadingWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  background-color: grey;
}
</style>
